import {
  put, all, call, select, takeLatest, fork, takeEvery,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { exception } from 'circe/logger';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import chunk from 'lodash/chunk';

import {
  fetch,
  fetching,
  fetched,
  updateStatus,
  updateLocation,
  failed,
  replaceShipments,
  fetchShipmentWaybill,
  fetchedShipmentWaybill,
  markLoaded,
  requestBulkAddressUpdate,
  startRequestBulkAddressUpdate,
  finishRequestBulkAddressUpdate,
} from './actions';

import { requestAddressUpdate } from '../actions';
import { fetched as trackingFetched } from '../tracking/actions';
import { fetch as fetchShipmentApi } from '../view/api';
import { fetch as fetchApi, fetchPdf } from './api';
import { getOrder } from './selectors';
import { morphShipmentToUI, morphUsingState } from './utils';
import { operatorClient } from '../../HttpClients';

const doFetch = function* ({ payload }) {
  try {
    const { oId } = payload;

    const state = yield select();

    yield put(fetching());

    const headers = yield call(getCurrentAuthHeader, state);

    const results = yield call(fetchApi, oId, headers);

    if (!results) {
      throw new Error(`Order View failed to load ${oId}`);
    }

    // const shipments = [];
    // yield loadBulkShipments(results);
    // TODO check this for better performance
    if (results.shipmentIds) {
      const { shipmentIds } = results;
      let i = 0;
      while (i < shipmentIds.length) {
        // yield delay(500);
        yield call(loadShipment, shipmentIds[i], results);
        yield put(markLoaded()); // TODO should be remove temp fix for performance
        i++;
      }
    }
  } catch (e) {
    yield put(failed());
    console.error(e);
    exception(e);
  }
};

function* loadBulkShipments(order) {
  const { shipmentIds: ids } = order;
  const state = yield select();
  const stateShipments = state.app.shipments.order.order.shipments || [];
  let shipments = [...stateShipments];

  const chunked = chunk(ids, 15);
  for (const chunk of chunked) {
    const ids = chunk.join(',');
    const result = yield operatorClient
      .Get('/api/shipments')
      .withParams({
        shipmentIds: ids,
      })
      .send();
    const { results } = result;
    for (const shipment of results) {
      shipments = shipments.concat(morphUsingState(morphShipmentToUI(shipment), state));
      yield put(fetched({ ...order, shipments }));
      yield put(markLoaded()); // TODO should be remove temp fix for performance
    }
  }
}

function* loadShipment(shipmentId, results) {
  const state = yield select();

  const stateShipments = state.app.shipments.order.order.shipments || [];
  let shipments = [...stateShipments];
  const headers = yield call(getCurrentAuthHeader, state);

  try {
    const resp = yield call(fetchShipmentApi, shipmentId, null, headers);
    if (resp) {
      shipments = shipments.concat(morphUsingState(morphShipmentToUI(resp), state));
      yield put(fetched({ ...results, shipments }));
    }
  } catch (e) {
    exception(e);
  }
}

function* doSaveTracking({ payload }) {
  const state = yield select();

  const { status, location, shipmentId } = payload.shipment;

  const order = yield call(getOrder, state);

  if (order.shipments) {
    const { hasShipment, shipments } = order.shipments.reduce(
      (acc, shipment) => {
        if (shipment.quote.shipmentId === shipmentId) {
          acc.hasShipment = true;
          acc.shipments.push({
            ...shipment,
            summary: {
              ...shipment.summary,
              location,
            },
            quote: {
              ...shipment.quote,
              status,
            },
          });
        } else {
          acc.shipments.push(shipment);
        }

        return acc;
      },
      { hasShipment: false, shipments: [] },
    );

    if (!hasShipment) {
      return;
    }

    yield put(replaceShipments(shipments));
  }

  // if (shipment.quote.shipmentId !== payload.shipment.shipmentId) {
  //   return;
  // }
  //
  // yield put(updateStatus(status));
  //
  // yield put(updateLocation(location));
}

function* doFetchWaybillPdf(context, { payload }) {
  try {
    const state = yield select();
    const headers = yield call(getCurrentAuthHeader, state);
    const { orderId } = payload;

    const resp = yield call(fetchPdf, orderId, { ...headers });

    if (!resp) {
      throw new Error('Fetch Shipments failed to load');
    }

    window.open(resp.file);
  } catch (e) {
    yield put(showNotification(I18n.str('unableToPrintFile', 'Unable to print waybill.'), 'error'));
    exception(e);
  }
}

function* doRequestBulkUpdate({ payload }) {
  try {
    const state = yield select();
    const headers = yield call(getCurrentAuthHeader, state);
    const { shipments } = payload;

    yield put(startRequestBulkAddressUpdate());

    const shipmentsChunks = chunk(shipments, 5);
    let i = 0;
    while (i < shipmentsChunks.length) {
      let x = 0;
      while (x < shipmentsChunks[i].length) {
        const { waybill, phone } = shipmentsChunks[i][x];
        yield put(requestAddressUpdate(waybill, phone));
        x++;
      }
      yield call(delay, 1000);
      i++;
    }
    yield put(finishRequestBulkAddressUpdate());
  } catch (e) {
    yield put(
      showNotification(I18n.str('unableToNotifyCustomers', 'Unable to notify customers.'), 'error'),
    );
    exception(e);
  }
}

export default function* (context) {
  yield all([
    takeLatest(fetch().type, doFetch),
    takeLatest(trackingFetched().type, doSaveTracking),
    takeLatest(fetchShipmentWaybill().type, doFetchWaybillPdf, context),
    takeLatest(requestBulkAddressUpdate().type, doRequestBulkUpdate),
  ]);
}
